import { useEffect, useCallback } from 'react'
import { Capacitor } from '@capacitor/core'
import { Purchases } from '@revenuecat/purchases-capacitor'
import {
    useClub,
    useSetStoreOfferings,
	useSetStoreOfferingsError,
	useUser,
} from './data'
import { getRevenueCatApiKey } from './revenueCat'
import { useRefreshStoreCustomerInfo } from './useRefreshStoreCustomerInfo'

const MyPurchases = () => {

	const user = useUser()
	const club = useClub()

	const setStoreOfferings = useSetStoreOfferings()
	const setStoreOfferingsError = useSetStoreOfferingsError()

	const refreshStoreCustomerInfoUser = useRefreshStoreCustomerInfo(user?.uid || '')
	const refreshStoreCustomerInfoClub = useRefreshStoreCustomerInfo(club?.id || '')

	const platform = Capacitor.getPlatform()
	const apiKey = getRevenueCatApiKey()
	if (!apiKey) {
		console.error("No API key for platform!", platform)
	}

	//
	// Initialize the CapacitorPurchases plugin.
	//
	// We don't send any user info yet.
	//
	const setupPurchasesOnDevice = useCallback(async () => {

		try {
			if (!apiKey) {
				throw new Error(`No RevenueCat API key for platform ${platform}`)
			}

			setStoreOfferingsError(null)

			await Purchases.configure({
				apiKey,
				// appUserID: uid,
				// observorMode: true,
			})

			const offerings = await Purchases.getOfferings()
			console.log('RevenueCat says offerings are:', offerings)
			setStoreOfferings(offerings)
		} catch (err) {
			console.error('RevenueCat setup failed', err)
			const message = err instanceof Error ? err.message : String(err)
			setStoreOfferingsError(message)
		}

	}, [ setStoreOfferings, setStoreOfferingsError, apiKey, platform ])

	useEffect(() => {
		if (Capacitor.isNativePlatform()) {
			setupPurchasesOnDevice()
		}
	}, [ setupPurchasesOnDevice ])

	useEffect(() => {
		if (Capacitor.isNativePlatform() && user?.uid) {
			try {
				Purchases.logIn({
					appUserID: user.uid,
				})
			} catch (err) {
				console.error("ERROR: Failed to log in user for CapacitorPurchases")
			}
		}
	}, [ user?.uid, setupPurchasesOnDevice ])

	//
	// When user/club changes, fetch RevenueCat CustomerInfo, so we can
	// tell whether they have purchased AutoRoster Pro.
	//

	/*
	//
	// On native, there doesn't seem to be a good way to fetch user & club info
	// separately, like we do for web.
	//
	// We have to always check both.
	//
	// And this is so wonky, I'm going to try to avoid it altogether.
	//
	// < Used to be a bunch of code here for fetchCustomerInfoForUserOnDevice() >
	*/

	//
	// Call the relevant one of the above functions when user.uid or club.id changes.
	//
	useEffect(() => {
		refreshStoreCustomerInfoUser()
	}, [ refreshStoreCustomerInfoUser ])

	useEffect(() => {
		refreshStoreCustomerInfoClub()
	}, [ refreshStoreCustomerInfoClub ])

	return null
}

export default MyPurchases
